'use client';

import { ParietteProvider } from './context';

const ClientParietteProvider = ({ children, locale }: { children: React.ReactNode; locale?: string | null }) => {
  return <ParietteProvider initialLocale={locale}>{children}</ParietteProvider>;
};

export default ClientParietteProvider;
